import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import '../../css/centeredContainer.css';



import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import '../../css/Home.css';

import LoadingSpinner from '../loadingSpinner/LoadingSpinner';
import Error from './Error';
import { motion } from "framer-motion";
import logo from '../../media/dnzify-logo-white-horizontal.png';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.6 } },
};

export default function Home({ isNavOpen }) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className={isNavOpen ? 'body-squeezed' : 'body'}>
      <div className="home">

        {/* HERO SECTION */}
        <section className="hero">

          <img
            src={logo}
            alt="Dnzify Logo"
            className="hero-logo"
          />

          <motion.div
            className="hero-content"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h1>{t('Home.empowerYourSchool')}</h1>
            <p>
              {t('Home.aModernPlatform')}
            </p>
            <button className="cta-btn">    <Link to="/demo">  {t('Home.seeItInAction')}</Link></button>
          </motion.div>
        </section>

        {/* ABOUT SECTION */}
        <section className="about">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{t('Home.teachSmarter')}</h2>
            <p>
              {t('Home.thisAppWasBuilt')}
            </p>
            <p style={{ 'marginTop': '1em' }}>
              {t('Home.uploadYourLessons')}
            </p>
          </motion.div>
        </section>

        {/* PARALLAX IMAGE SECTION */}
        <section className="parallax parallax1">
          <motion.div
            className="overlay-text"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{t('Home.yourSchoolYourBrand')}</h2>
            <p>
              {t('Home.customizeAccess')}
            </p>
          </motion.div>
        </section>

        {/* FEATURES SECTION */}
        <section className="feature-section">
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {t('Home.keyFeatures')}
          </motion.h2>
          <div className="feature-grid">
            {[
              {
                title: t('Home.grid.title1'),
                text: t('Home.grid.text1'),
              },
              {
                title: t('Home.grid.title2'),
                text: t('Home.grid.text2'),
              },
              {
                title: t('Home.grid.title3'),
                text: t('Home.grid.text3'),
              },
              {
                title: t('Home.grid.title4'),
                text: t('Home.grid.text4'),
              },
              {
                title: t('Home.grid.title5'),
                text: t('Home.grid.text5'),
              },
            ].map((feature, idx) => (
              <motion.div
                key={idx}
                className="feature"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
              >
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* PARALLAX IMAGE SECTION */}
        <section className="parallax parallax2">
          <motion.div
            className="overlay-text"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{t('Home.keepEngaged')}</h2>
          </motion.div>
        </section>

        {/* BENEFITS SECTION */}
        <section className="benefits">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{t('Home.whatThisMeans')}</h2>
            <p>
              {t('Home.moreValue')}
            </p>
            <ul>
              <li> {t('Home.valueList.value1')}</li>
              <li> {t('Home.valueList.value2')}</li>
              <li> {t('Home.valueList.value3')}</li>
              <li> {t('Home.valueList.value4')}</li>
              <li> {t('Home.valueList.value5')}</li>
            </ul>
          </motion.div>
        </section>

        {/* CALL TO ACTION */}
        <section className="cta-section">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{t('Home.bringYourStudio')}</h2>
            <p>
              {t('Home.watchVideos')}
            </p>
            <button className="schedule-btn">    <Link to="/demo">{t('Home.seeItInAction')}</Link></button>
          </motion.div>
        </section>


        {/* HOME FOOTER SECTION */}
        <section className="home-footer">
          <div className="home-footer-content">

            <img
              src={logo}
              alt="Dnzify logo"
              className="home-footer-logo"
            />

            <div className="home-footer-socials">
              <a
                href="https://instagram.com/dnzify"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>

              <a
                href="https://www.linkedin.com/company/dnzify/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>

            </div>

            <div className="home-footer-legal">
              <Link to="/legal/terms">
                {t('Home.footer.termsOfUse')}
              </Link>

              <span className="legal-separator">·</span>

              <Link to="/legal/privacy">
                {t('Home.footer.privacyPolicy')}
              </Link>

              <span className="legal-separator">·</span>

              <a href="mailto:contact@dnzify.com" target="_blank" rel="noopener noreferrer">
                {t('Plans.contactUs')}
              </a>


            </div>

            <p className="home-footer-text">
              © {new Date().getFullYear()} Dnzify · Vancouver, B.C. · {t('Home.footer.allRightsReserved')}
            </p>

          </div>
        </section>



      </div>


    </div>


  );
}
